<div class="page-title-area" style="padding-bottom: 20px !important">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="javascript:void(0)"  (click)="home()">Accueil</a></li>
                <li><a href="javascript:void(0)" (click)="gotoLevel()">Niveau {{level}}</a></li>
                <li><a routerLink="/student">{{title}}</a></li>
            </ul>
        </div>
    </div>
</div>
<div class="container">
    <div class="row h-100 justify-content-center align-items-center">
        <div class="col-sms-12 col-lg-12 col-md-12">
    <ngx-extended-pdf-viewer  [src]="pdfSrc"  [customToolbar]="additionalButtons"
        [useBrowserLocale]="true"   [handTool]="false">
    </ngx-extended-pdf-viewer>
    <ng-template #additionalButtons>
        <div id="toolbarViewer" style="background-color: #5d1437 !important;">
            <div id="toolbarViewerLeft">
                <pdf-toggle-sidebar></pdf-toggle-sidebar>
                <div class="toolbarButtonSpacer"></div>
                <pdf-find-button [showFindButton]="true" [textLayer]="true"></pdf-find-button>
                <pdf-paging-area></pdf-paging-area>
            </div>
            <pdf-zoom-toolbar></pdf-zoom-toolbar>
        </div>
    </ng-template>
        </div>
    </div>
</div>